import {COMMON_ACTION_TYPES, FACTORY_ACTION_TYPES} from "../../_constants";

const INITIAL_STATE = {
    sbuList: {
        isLoading: false,
        data: [],
    },
    plantList: {
        isLoading: false,
        data: [],
    },
    factoryList: {
        isLoading: false,
        data: [],
    },
    createFactory: {
        isLoading: false,
        data: [],
    }
};

const factoryReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        // get SBU List
        case FACTORY_ACTION_TYPES.GET_SBU_LIST + COMMON_ACTION_TYPES.REQUEST:
            return {
                ...state,
                sbuList: {
                    isLoading: true,
                    data: [],
                }
            };

        case FACTORY_ACTION_TYPES.GET_SBU_LIST + COMMON_ACTION_TYPES.SUCCESS:
            return {
                ...state,
                sbuList: {
                    isLoading: false,
                    data: action.data
                }
            };

        case FACTORY_ACTION_TYPES.GET_SBU_LIST + COMMON_ACTION_TYPES.ERROR:
            return {
                ...state,
                sbuList: {
                    isLoading: false,
                    data: [],
                }
            };

        // get Plant List
        case FACTORY_ACTION_TYPES.GET_PLANT_LIST + COMMON_ACTION_TYPES.REQUEST:
            return {
                ...state,
                plantList: {
                    isLoading: true,
                    data: [],
                }
            };

        case FACTORY_ACTION_TYPES.GET_PLANT_LIST + COMMON_ACTION_TYPES.SUCCESS:
            return {
                ...state,
                plantList: {
                    isLoading: false,
                    data: action.data
                }
            };

        case FACTORY_ACTION_TYPES.GET_PLANT_LIST + COMMON_ACTION_TYPES.ERROR:
            return {
                ...state,
                plantList: {
                    isLoading: false,
                    data: [],
                }
            };
        //    Get Factory List
        case FACTORY_ACTION_TYPES.GET_FACTORY_LIST + COMMON_ACTION_TYPES.REQUEST:
            return {
                ...state,
                factoryList: {
                    isLoading: true,
                    data: [],
                }
            };

        case FACTORY_ACTION_TYPES.GET_FACTORY_LIST + COMMON_ACTION_TYPES.SUCCESS:
            return {
                ...state,
                factoryList: {
                    isLoading: false,
                    data: action.data
                }
            };

        case FACTORY_ACTION_TYPES.GET_FACTORY_LIST + COMMON_ACTION_TYPES.ERROR:
            return {
                ...state,
                factoryList: {
                    isLoading: false,
                    data: [],
                }
            };
        //    Create Factory
        case FACTORY_ACTION_TYPES.CREATE_FACTORY + COMMON_ACTION_TYPES.REQUEST:
            return {
                ...state,
                createFactory: {
                    isLoading: true,
                    data: [],
                }
            };

        case FACTORY_ACTION_TYPES.CREATE_FACTORY + COMMON_ACTION_TYPES.SUCCESS:
            return {
                ...state,
                createFactory: {
                    isLoading: false,
                    data: action.data
                }
            };

        case FACTORY_ACTION_TYPES.CREATE_FACTORY + COMMON_ACTION_TYPES.ERROR:
            return {
                ...state,
                createFactory: {
                    isLoading: false,
                    data: [],
                }
            };

        default:
            return state;
    }
}

export default factoryReducer;
